import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

class ChangePhoneNumberModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  initialState = {
    userId: this.props.userId,
    phoneNumber: this.props.phoneNumber,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.phoneNumber != this.props.phoneNumber) {
      this.setState({
        phoneNumber: this.props.phoneNumber,
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  changeUserPhoneNumber(e) {
    e.preventDefault();
    this.props.handleSubmit(this.state);
    this.setState(this.initialState);
  }

  render() {
    let { open, toggle } = this.props;
    let { phoneNumber } = this.state;
    return (
      <>
        <Modal isOpen={open} fade={false} toggle={toggle}>
          <ModalHeader toggle={toggle}>Đổi số điện thoại</ModalHeader>
          <ModalBody>
            <div class="row">
              <div class="col-md-12">
                <Form onSubmit={(e) => this.changeUserPhoneNumber(e)}>
                  <FormGroup>
                    <Label>Số điện thoại mới</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={phoneNumber}
                      name="phoneNumber"
                    />
                  </FormGroup>
                  <Button className="mb-2 me-2" type="submit">
                    Đồng ý
                  </Button>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ChangePhoneNumberModal;
